import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './styles.module.scss';

export const RibbonTag = props => {
    const {
        dot,
        children,
        direction,
        backgroundColor,
        shadow,
        dotColor,
    } = props;

    return (
        <div
            className={classNames(styles.ribbonTagWrapper, shadow ? styles.shadow : '')}
            style={{ backgroundColor }}
        >
            {direction === 'left' && (
                <span
                    className={styles.triangleLeft}
                    style={{ borderRight: `12px solid ${backgroundColor}` }}
                >
                    {dot && (
                        <span
                            style={{ background: dotColor }}
                            className={styles.dot}
                        />
                    )}
                </span>
            )}
            <span className={styles.content}>{children}</span>
            {direction === 'right' && (
                <span
                    className={styles.triangleRight}
                    style={{ borderLeft: `12px solid ${backgroundColor}` }}
                >
                    {dot && (
                        <span
                            className={styles.dot}
                            style={{ background: dotColor }}
                        />
                    )}
                </span>
            )}
        </div>
    );
};

RibbonTag.propTypes = {
    direction: PropTypes.string,
    backgroundColor: PropTypes.string,
    children: PropTypes.any,
    dot: PropTypes.bool,
    shadow: PropTypes.bool,
    dotColor: PropTypes.string,
};

RibbonTag.defaultProps = {
    direction: 'right',
    children: null,
    backgroundColor: '#D70047',
    dot: true,
    shadow: false,
    dotColor: 'white',
};
